import { Outlet } from "react-router-dom";
import NavBar from "../../components/LandingPage/Navbar";
import Footer from "../../components/LandingPage/Footer";

function HomeLayout() {
  return (
    <div className="d-flex flex-column vh-100">
      <NavBar />

      <div
        className="flex-grow-1 overflow-auto w-100"
        style={{ paddingTop: "90px" }}
      >
        <div className="container-fluid px-0">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default HomeLayout;
